import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LeadsState, Quiz } from '../../types';

const initialState: LeadsState = {
  quizResult: {
    sessionId: null,
    quiz: [],
  },
  matchedLeads: [],
};

const leadsSlice = createSlice({
  name: 'leads',
  initialState,
  reducers: {
    setMatchedLeads: (state, action: PayloadAction<Record<string, any>[]>) => {
      state.matchedLeads = action.payload;
    },
    setQuizResult: (state, action: PayloadAction<{sessionId: string | null, quiz: Quiz[]}>) => {
      state.quizResult = action.payload;
    },
  },
});

export const { 
  setQuizResult, 
  setMatchedLeads, 
} = leadsSlice.actions;

export default leadsSlice.reducer;
